import { useQuery } from "@tanstack/react-query";
import { userService } from "@/services/userService";

export const useTelecallers = () => {
  const query = useQuery({
    queryKey: ["telecallers"],
    queryFn: async () => {
      const response = await userService.getUsers({ limit: 1000 });
      const users = response?.data || response?.employees || (Array.isArray(response) ? response : []);
      console.log("DEBUG - useTelecallers raw users:", users?.length, users);

      // Filter for specific roles: Telecallers, Admins, and Owners only
      const filtered = users.filter(u => {
        const role = String(u.role || "").toLowerCase();
/*developer: Nithin
    date : 2024-06-19
    changes : Replaced Telecaller With Staff */
    
        const isMatch = role.includes('tele') ||
          role === 'client_coordinator' ||
          role === 'admin' ||
          role === 'owner' ||
          role === 'Verve-admin' ||
          role === 'systemadmin';

        if (isMatch) console.log(`DEBUG - Matched Telecaller: ${u.name} (${u.role})`);
        return isMatch;
      });

      console.log("DEBUG - Filtered Telecallers result count:", filtered.length);
      return filtered;
    },
    staleTime: 0 // Always fetch fresh data while debugging
  });

  return {
    telecallers: query.data || [],
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch
  };
};
